import axios from 'axios';
import qs from 'qs';

// 默认请求路径
// axios.defaults.baseURL = '/';

// 超时时间
axios.defaults.timeout = 2000;

axios.defaults.withCredentials = true;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

axios.interceptors.request.use((config) => {
    // 在此处可以进行请求头的设置
    /* eslint-disable no-console */
    return config;
}, err => {
    return Promise.error(err);
})

axios.interceptors.response.use(response => {
    if(response.status === 200) {
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
}, err => {
    // 响应状态码不是200的时候进行判断
    return Promise.reject(err);
})

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params}).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}

export function post(url, params, headers = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(params), {
            headers
        })
        .then(res => {
            resolve(res.data);
        })
        .catch(err => {
            reject(err.data)
        })
    })
}
